import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RoleRestService } from 'app/admin/roles/role-rest.service';

@Component({
  selector: 'app-add-article-arabic',
  templateUrl: './add-article-arabic.component.html',
  styleUrls: ['./add-article-arabic.component.scss']
})
export class AddArticleArabicComponent implements OnInit {
  registerForm: FormGroup
  serverErrors = [];
  constructor(private auth: RoleRestService, private route: Router) { }

  ngOnInit() {
    this.registerForm = new FormGroup({
      'title': new FormControl(null, [Validators.required, Validators.minLength(10)]),
      'content': new FormControl(null, [Validators.required, Validators.minLength(5)]),
      'img': new FormControl(null, [Validators.required]),
   })
  }

  get Titre() { return this.registerForm.get('title'); }
  get Contenu() { return this.registerForm.get('content')};
  get Image() { return this.registerForm.get('img') }
  addPost()
  {
    this.auth.addPost(this.registerForm).subscribe(res=>{
      this.route.navigate(['/ar/home'])
    },err=>{
      //console.log(err)
    })
  }

}
